import { __assign } from "tslib";
require('es6-shim'); //tslint:disable-line
import { TicketStatus } from '@wix/answers-api';
import { AppEventType } from '../app/';
import { getTimelineItemData, createWixLogger } from './wix-utils';
import { sanitizePII } from '@wix/bi-logger-sanitizer';
export var createWixTicketHandler = function (baseData, webBiLogger) {
    var logger = createWixLogger(false, webBiLogger);
    var base = {
        tenant_id: baseData.tenantId,
        user_id: baseData.userId
    };
    return function (event) {
        switch (event.type) {
            case AppEventType.TICKET_REPLY_ADD_ATTEMPT: {
                var _a = event.data, ticketId = _a.ticketId, goToTicketList = _a.goToTicketList, newStatus = _a.newStatus;
                return logger.appTicketsAddReplyAttempt(__assign(__assign({}, base), { ticket_id: ticketId, reply_and_go_to_tickets_list: goToTicketList, resolution: TicketStatus[newStatus], reply_type: 'reply' }));
            }
            case AppEventType.TICKET_REPLY_ADD_FAIL: {
                var _b = event.data, ticketId = _b.ticketId, goToTicketList = _b.goToTicketList, newStatus = _b.newStatus, reason = _b.reason;
                return logger.appTicketsAddReplyFail(__assign(__assign({}, base), { ticket_id: ticketId, reply_and_go_to_tickets_list: goToTicketList, resolution: TicketStatus[newStatus], reply_type: 'reply', failReason: reason }));
            }
            case AppEventType.TICKET_TEAM_NOTE_ADD_ATTEMPT:
                return logger.appTicketsAddReplyAttempt(__assign(__assign({}, base), { ticket_id: event.data.ticketId, reply_type: 'team-note' }));
            case AppEventType.TICKET_TEAM_NOTE_ADD_FAIL:
                return logger.appTicketsAddReplyFail(__assign(__assign({}, base), { ticket_id: event.data.ticketId, reply_type: 'team-note', failReason: event.data.reason }));
            case AppEventType.TICKET_SWITCH_REPLY_TYPE:
                return logger.appTicketsSwitchReplyType(__assign(__assign({}, base), { ticket_id: event.data.ticketId, switch_to: event.data.switchToType }));
            case AppEventType.TICKET_DELETE_TIMELINE_ITEM: {
                var _c = getTimelineItemData(event.data.item), ticketId = _c.ticketId, replyId = _c.replyId, replyType = _c.replyType, content = _c.content;
                return logger.appTicketsDeleteAReplyClick(__assign(__assign({}, base), { ticket_id: ticketId, reply_id: replyId, reply_type: replyType, content: content }));
            }
            case AppEventType.TICKET_DELETE_TIMELINE_ITEM_CONFIRM: {
                var _d = getTimelineItemData(event.data.item), ticketId = _d.ticketId, replyId = _d.replyId, replyType = _d.replyType, content = _d.content;
                return logger.appTicketsOneInboxDeleteAReplyConfirm(__assign(__assign({}, base), { ticket_id: ticketId, reply_id: replyId, reply_type: replyType, content: content }));
            }
            case AppEventType.TICKET_DELETE_TIMELINE_ITEM_CANCEL: {
                var _e = getTimelineItemData(event.data.item), ticketId = _e.ticketId, replyId = _e.replyId, replyType = _e.replyType, content = _e.content;
                return logger.appTicketsOneInboxDeleteAReplyCancel(__assign(__assign({}, base), { ticket_id: ticketId, reply_id: replyId, reply_type: replyType, content: content }));
            }
            case AppEventType.TICKET_DELETE:
                return logger.appTicketsOneInboxDeleteATicketClick(__assign(__assign({}, base), { status_id: event.data.ticket.status, status_name: TicketStatus[event.data.ticket.status], ticket_id: event.data.ticket.id }));
            case AppEventType.TICKET_DELETE_CONFIRM:
                return logger.appTicketsOneInboxDeleteATicketConfirm(__assign(__assign({}, base), { status_id: event.data.ticket.status, status_name: TicketStatus[event.data.ticket.status], ticket_id: event.data.ticket.id, is_blocked: event.data.blockUser }));
            case AppEventType.TICKET_CLICK_REPLY_AREA_ICON: {
                var _f = event.data, source = _f.source, type = _f.type, ticketId = _f.ticketId;
                return logger.appTicketsClickOnAnIcon(__assign(__assign({}, base), { source: source, icon_type: type, ticket_id: ticketId }));
            }
            case AppEventType.TICKET_REPLY_ADD_EMOJI: {
                var _g = event.data, source = _g.source, type = _g.type, ticketId = _g.ticketId;
                return logger.appTicketsEmojiAddedToReply(__assign(__assign({}, base), { source: source, emoji_type: type, ticket_id: ticketId }));
            }
            case AppEventType.TICKET_REPLY_ADD_ATTACHMENT: {
                var _h = event.data, source = _h.source, type = _h.type, ticketId = _h.ticketId;
                return logger.appTicketsAttachmentAddedToReply(__assign(__assign({}, base), { source: source, attachment_type: type, ticket_id: ticketId }));
            }
            case AppEventType.TICKET_LIST_SEARCH: {
                var _j = event.data, searchTerm = _j.searchTerm, results = _j.results;
                return logger.appTicketsSearchForATicket(__assign(__assign({}, base), { search_term: searchTerm, number_of_related_tickets: results.count, first_answer: results.tickets.length ? sanitizePII(results.tickets[0].subject) : undefined }));
            }
            case AppEventType.TICKET_LIST_CREATE_TICKET_START:
                return logger.appTicketsPressButtonCreateTicket(__assign({}, base));
            case AppEventType.TICKET_LIST_CREATE_TICKET:
                return logger.appTicketsCreateATicket(__assign({}, base));
            case AppEventType.TICKET_LIST_SELECT_TICKET: {
                var _k = event.data, ticket = _k.ticket, position = _k.position;
                return logger.appTicketsOneInboxClickOnATicket(__assign(__assign({}, base), { ticket_id: ticket.id, position: position, source: 'ticket-list' }));
            }
            default:
                // some ticket event are still being handled in wix handler
                return Promise.resolve();
        }
    };
};
//# sourceMappingURL=wix-tickets.js.map